import clsx from "clsx";
import { ReactNode } from "react";
import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

type Props = {
  color?: "red" | "green" | "blue" | "orange" | "blue1";
  children: ReactNode;
  className?: string;
  colorManual?: string;
  isDisabled?: boolean;
};

function Badge({
  color = "green",
  children,
  className,
  colorManual,
  isDisabled,
}: Props) {
  const classes = useStyles();
  return (
    <span
      className={clsx(
        color === "green" && classes.green,
        color === "red" && classes.red,
        color === "blue" && classes.blue,
        color === "blue1" && classes.blue1,
        color === "orange" && classes.orange,
        className || ""
      )}
      style={{
        background: colorManual || "",
        opacity: isDisabled ? 0.5 : 1,
      }}
    >
      {children}
    </span>
  );
}

const useStyles = createUseStyles(() => ({
  base: {
    color: theme.color.white,
    padding: [2, 3],
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  green: {
    composes: "$base",
    background: theme.color.green,
  },
  red: {
    composes: "$base",
    background: theme.color.red,
  },
  blue: {
    composes: "$base",
    background: theme.color.blueLight2,
  },
  blue1: {
    composes: "$base",
    background: theme.color.blueLight,
  },
  orange: {
    composes: "$base",
    background: theme.color.orange,
  },
}));

export default Badge;
